import styles from './lib/DropDown.css?inline';
import { customElement } from 'solid-element';
import { DropDown } from './lib/DropDown';

const DropDownWithStyles = (props: any, { element }: { element: HTMLElement }) => {
    return (
        <>
        <style>{ styles } </style>
        < DropDown {...props } />
            </>
  );
};

// Register the custom element
customElement('solid-drop-down', {
    document: undefined as any,
    template: undefined as any,
    componentDefinition: undefined as any,
    fieldValue: '',
    fieldName: '',
    previousFieldValue: '',
    key: 0,
    formParameters: undefined as any,
}, DropDownWithStyles);

// Export the component for testing
export { DropDown };
